<template>
  <div>
    <content-top
      v-show="objects.length"
      title="Lista kategorii SPIM"
      :subheading="
        `${objects.length} 
          ${$options.filters.numeralsText(
            objects.length,
            'kategoria SPIM',
            'kategorie SPIM',
            'kategorii SPIM'
          )}`
      "
    ></content-top>
    <div class="spim-loader-container" :class="{ 'is-loading': isLoading }">
      <spim-loader></spim-loader>
      <add-button
        @addObject="addObject"
        textButton="Dodaj"
        :icon="true"
      ></add-button>
      <div class="content col-24">
        <table class="items-table items-table--shrink">
          <thead class="items-table__thead">
            <tr class="items-table__tr">
              <th class="items-table__th items-table__th--sm">ID</th>
              <th class="items-table__th">Nazwa</th>
              <th class="items-table__th p-0 text-right">Akcje</th>
            </tr>
          </thead>

          <tbody class="items-table__tbody">
            <template v-for="object in objects">
              <tr class="items-table__tr" v-bind:key="object.id">
                <td class="items-table__td items-table__td--sm">
                  <div class="form-box__mobile-element">Id</div>
                  {{ object.id }}
                </td>

                <td class="items-table__td">
                  <div class="form-box__mobile-element">Nazwa</div>
                  <div>
                    {{ object.name }}
                  </div>
                </td>
                <td class="items-table__td items-table__td--button">
                  <div class="form-box__mobile-element">Akcje</div>
                  <div class="d-flex justify-content-end">
                    <button
                      class="button-icon"
                      @click.prevent="editObject(object)"
                    >
                      <icon icon="edit" />
                    </button>

<!--                    <button-->
<!--                      class="button-icon button-icon&#45;&#45;ml-10"-->
<!--                      @click="deleteObject(object)"-->
<!--                    >-->
<!--                      <icon icon="trash" />-->
<!--                    </button>-->
                  </div>
                </td>
              </tr>
            </template>
          </tbody>
        </table>
      </div>
    </div>

    <!-- Modal delete -->
    <modal
      :show="showDeleteModal"
      size="md"
      @close="showDeleteModal = !showDeleteModal"
    >
      <div slot="header" class="notice-modal__header--title">
        Usuwanie elementu
      </div>

      <div slot="body">
        <div>
          Czy napewno chcesz usunąć ten element
          <strong>{{
            "#" + objectToDelete.id + " - " + objectToDelete.name
          }}</strong
          >?
        </div>
      </div>

      <div slot="footer" class="d-flex align-items-center">
        <button
          class="button button--small button--grey"
          @click="showDeleteModal = false"
        >
          Nie
        </button>
        <button
          class="button button--small button--ml-10"
          @click="confirmDeleteObject()"
        >
          Tak
        </button>
      </div>
    </modal>

    <!-- Modal edit -->
    <modal
      :show="showEditModal"
      size="lg"
      @close="showEditModal = !showEditModal"
    >
      <div slot="header" class="notice-modal__header--title">
        Edycja elementu
      </div>

      <div slot="body">
        <div class="row">
          <div class="col-24">
            <div class="form-box">
              <label class="form-box__label form-box__label--mt">
                Nazwa:
              </label>
              <input v-model="editingObject.name" class="form-box__input" />
              <label class="form-box__label form-box__label--mt">
                Atrybuty:
              </label>
              <draggable
                v-model="editingObject.attributes"
                class="mt-2"
                @change="changeOrder"
              >
                <div
                  v-for="attribute in editingObject.attributes"
                  v-bind:key="attribute"
                >
                  <div class="tree-list__item tree-list__item--draggable">
                    <div class="tree-list__cat">
                      <div class="d-flex">
                        <icon icon="drag-indicator" />
                        {{ attribute.name }}
                      </div>
                      <div class="tree-list__actions">
<!--                        <button-->
<!--                          class="button-icon button-icon&#45;&#45;ml-10"-->
<!--                          @click="deleteAttribute(attribute)"-->
<!--                          data-tooltip="Usuń"-->
<!--                        >-->
<!--                          <icon icon="trash" />-->
<!--                        </button>-->
                      </div>
                    </div>
                  </div>
                </div>
              </draggable>

              <div class="row mt-4">
                <div class="col-19">
                  <treeselect
                    class="vue-treeselect"
                    v-if="attributes.length > 0"
                    v-model="newAttribute"
                    :multiple="false"
                    :options="attributes"
                    :normalizer="normalizer"
                    :clearable="false"
                    valueFormat="node"
                  />

                  <div
                    v-else
                    class="product-form__note"
                    v-text="
                      isLoading
                        ? 'Ładowanie...'
                        : 'Nie dodano jeszcze tego elementu do słowników.'
                    "
                  ></div>
                </div>
                <div class="col-5">
                  <button
                    class="button button--small button--ml-10"
                    @click="addAttribute()"
                  >
                    Dodaj atrybut
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div slot="footer" class="d-flex align-items-center">
        <button
          class="button button--small button--ml-10"
          @click="updateObject(editingObject)"
        >
          Zapisz
        </button>
      </div>
    </modal>

    <!-- Modal add -->
    <modal :show="showAddModal" size="lg" @close="showAddModal = !showAddModal">
      <div slot="header" class="notice-modal__header--title">
        Dodawanie elementu
      </div>

      <div slot="body">
        <div class="row">
          <div class="col-24">
            <div class="form-box">
              <label class="form-box__label form-box__label--mt">
                Nazwa:
              </label>
              <input v-model="addingObject.name" class="form-box__input" />
              <label class="form-box__label form-box__label--mt">
                Atrybuty:
              </label>
              <treeselect
                class="vue-treeselect"
                v-if="attributes.length > 0"
                v-model="addingObject.attributes"
                :multiple="true"
                :options="attributes"
                :normalizer="normalizer"
                :clearable="false"
              />
              <div
                v-else
                class="product-form__note"
                v-text="
                  isLoading
                    ? 'Ładowanie...'
                    : 'Nie dodano jeszcze tego elementu do słowników.'
                "
              ></div>
            </div>
          </div>
        </div>
      </div>

      <div slot="footer" class="d-flex align-items-center">
        <button
          class="button button--small button--ml-10"
          @click="createObject(addingObject)"
        >
          Zapisz
        </button>
      </div>
    </modal>
  </div>
</template>

<script>
import axios from "axios";
const API_BASE_URL = process.env.VUE_APP_API_BASE_URL;
import Icon from "./../parts/Icon";
import Modal from "./../parts/Modals/Modal";
import Treeselect from "@riophae/vue-treeselect";
import { changeObjectToArray } from "../../helpers/objectToArray";
import SpimLoader from "../parts/SpimLoader.vue";
import ContentTop from "../parts/ContentTop.vue";
import AddButton from "../parts/buttons/addButton.vue";
import draggable from "vuedraggable";

export default {
  data() {
    return {
      isLoading: true,
      objects: {},
      newObject: {},
      showDeleteModal: false,
      showEditModal: false,
      showAddModal: false,
      editingObject: {},
      addingObject: {},
      objectToDelete: {},
      attributes: {},
      newAttribute: null,
      normalizer(node) {
        return {
          id: node.id,
          label: node.name,
        };
      },
    };
  },
  components: {
    Icon,
    Modal,
    Treeselect,
    SpimLoader,
    ContentTop,
    AddButton,
    draggable,
  },
  async created() {
    this.getObjects();
  },
  methods: {
    addAttribute() {
      this.editingObject.attributes.push(this.newAttribute);
      this.deleteFromArraySelect(this.newAttribute.id);
      this.newAttribute = null;
    },
    deleteFromArraySelect(id) {
      this.attributes = this.attributes.filter(
        (attribute) => attribute.id !== id
      );
    },
    deleteAttribute(attributeToDelete) {
      this.editingObject.attributes = this.editingObject.attributes.filter(
        (attribute) => attribute.id !== attributeToDelete.id
      );
      this.getAttributes();
    },
    changeOrder() {
      this.editingObject.attributes.forEach((attribute, index) => {
        attribute["order"] = index + 1;
      });
    },
    async createObject(data) {
      let vm = this;
      try {
        const response = await axios.post(
          API_BASE_URL + "/spim-categories",
          data
        );
        vm.objects = response.data;
        this.addingObject = {};
        this.showAddModal = false;
        this.$root.$emit("noticesBox", {
          type: "success",
          message: "Poprawnie dodano kategorię.",
        });
      } catch (error) {
        vm.$root.$emit("noticesBox", error.response.data);
      }
    },
    async updateObject(data) {
      this.$root.$emit("noticesBox", {
        type: "success",
        message:
          "Trwa zapisywanie kategorii. Za chwilę dane zostaną zaktualizowane.",
      });

      // data.attributes = this.changeObjectToArray(data.attributes);
      try {
        const response = await axios.put(
          API_BASE_URL + "/spim-categories/" + data.id,
          data
        );
        this.objects = response.data;
        this.editingObject = {};
        this.showEditModal = false;
        this.$root.$emit("noticesBox", {
          type: "success",
          message: "Poprawnie zapisano kategorię.",
        });
      } catch (error) {
        this.$root.$emit("noticesBox", error.response.data);
      }
    },
    async getObjects() {
      this.isLoading = true;
      try {
        const response = await axios.get(API_BASE_URL + "/spim-categories");
        this.objects = response.data;
        this.isLoading = false;
      } catch (error) {
        this.isLoading = false;
        this.$root.$emit("noticesBox", error.response.data);
      }
    },
    async getAttributes() {
      this.isLoading = true;
      try {
        const response = await axios.get(API_BASE_URL + "/attributes");
        this.attributes = response.data;
        this.editingObject.attributes.forEach((attribute) => {
          this.deleteFromArraySelect(attribute.id);
        });
        this.isLoading = false;
      } catch (error) {
        this.isLoading = false;
        this.$root.$emit("noticesBox", error.response.data);
      }
    },
    async deleteObject(object) {
      this.showDeleteModal = true;
      this.objectToDelete = object;
    },
    async confirmDeleteObject() {
      this.showDeleteModal = false;
      try {
        await axios.delete(
          API_BASE_URL + "/spim-categories/" + this.objectToDelete.id
        );
        this.getObjects();
      } catch (error) {
        this.$root.$emit("noticesBox", error.response.data);
      }
    },
    editObject(object) {
      this.editingObject = { ...object };
      this.getAttributes();
      this.showEditModal = true;
    },
    addObject() {
      this.showAddModal = true;
    },
    addOption() {
      this.editingObject.options.push(this.newOption);
      this.newOption = {};
    },
    deleteOption(option) {
      var index = this.editingObject.options.indexOf(option);
      this.editingObject.options.splice(index, 1);
    },
    editOption(option) {
      this.editingOption = option;
    },
    saveOption() {
      this.editingOption = {};
    },
    changeObjectToArray,
  },
};
</script>
